module.exports = __webpack_public_path__ + "static/img/sub-page01@m.0d04ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/sub-page01@m.jpg
// module id = GfIi
// module chunks = 0